import { makeAutoObservable } from "mobx";
import { onError } from "src/common/onError";
import { ZUid } from "src/types/zUid";
import { ZAvaliableCopyAttrData } from "./CopyByValueEdit.types";
import { loadCbvLinkAttributes } from "./loadCbvLinkAttributes";
import { CopyByValueSettingsItem } from "./CopyByValueForm/CopyByValueSettingsItem";

export type ParamsCopyByValueStore = {
  objectId: ZUid;
  attrId: ZUid;
  typesMap: Record<number, string>;
  valueType: number;
};

export class CopyByValueStore {
  constructor(public readonly params: ParamsCopyByValueStore) {
    makeAutoObservable(this);
    this.init();
  }

  /**
   * все данные для настройки копирования, которые доступны текущему типу атрибута
   * в текущем объекте
   */
  avaliableCopyAttrData: ZAvaliableCopyAttrData[] = [];

  setAvaliableCopyAttrData(list: ZAvaliableCopyAttrData[]) {
    this.avaliableCopyAttrData = list;
  }

  open: boolean = false;

  setOpen(flag: boolean) {
    this.open = flag;
  }

  loading: boolean = false;

  setLoading(flag: boolean) {
    this.loading = flag;
  }

  async init() {
    const { objectId, valueType } = this.params;
    try {
      this.setLoading(true);
      this.setAvaliableCopyAttrData(
        await loadCbvLinkAttributes(objectId, valueType),
      );
    } catch (error) {
      onError(error);
    } finally {
      this.setLoading(false);
    }
  }

  typeDependentSettings: CopyByValueSettingsItem[] = [];

  setTypeDependentSettings(list: CopyByValueSettingsItem[]) {
    this.typeDependentSettings = list;
  }
}
